import { OutlookRecipientDto } from "@/out-look/dto";
import {
  RemoveResourcesFromOutlookRequest,
  AddResourceToOutlookRequest,
  RemoveResourceFromOutlookRequest,
  GetOutlookAppointmentResponse,
} from "./models";

export const TokenIOutlookAppointmentService = "IOutlookAppointmentService";

export interface IOutlookAppointmentService {
  GetCurrentAppointment(): GetOutlookAppointmentResponse | undefined;
  GetCurrentRecipients(): OutlookRecipientDto[];
  AddResource(request: AddResourceToOutlookRequest): boolean;
  RemoveResource(request: RemoveResourceFromOutlookRequest): boolean;
  RemoveResources(request: RemoveResourcesFromOutlookRequest): boolean;
  // SetLocations(request: SetLocationToOutlookRequest): boolean;
  // SetRecipients(request: SetRecipientsToOutlookRequest): boolean;
  // UpdateBaseInfo(request: UpdateAppointmentBaseInfoRequest): boolean;
  UpdateApptDateTimeInOrganizerTimeZone(start: Date, end: Date): void;
  IsNewBooking(): boolean;
  UpdateBodyForSendToAll(
    sessionKey: string,
    sendToAll: boolean
  ): Promise<boolean>;
  GetMessageUrl(): string;
}
